import React from 'react';

export const BlueDivider = () => {
  return <hr style={{borderTop: "1px dotted lightblue"}}/>
}

export default BlueDivider;